import { gql } from '@apollo/client'

import { SHOP_GIFT_CARD_VARIANT_FRAGMENT } from './giftCardVariant'

export const SHOP_GIFT_CARD_FRAGMENT = gql`
  fragment ShopGiftCard on ShopGiftCardInterface {
    id
    kind
    note
    termsText
    variants {
      ...ShopGiftCardVariant
    }

    ... on ShopGiftCardPhysical {
      pickUpEnabled
      shippingEnabled
    }
  }
  ${SHOP_GIFT_CARD_VARIANT_FRAGMENT}
`
